import modules from './modules/modules';

const functionsInit = () => {
    modules();
};

export default functionsInit;
